"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataAliasNestedService", {
    enumerable: true,
    get: function() {
        return DataAliasNestedService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("~/helpers/catchError");
const _PagedResponse = require("~/helpers/PagedResponse");
const _dataHelpers = require("~/helpers/dataHelpers");
const _models = require("~/models");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let DataAliasNestedService = class DataAliasNestedService {
    // todo: handle case where the given column is not ltar
    async mmList(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        if (!model) _catchError.NcError.tableNotFound(param.tableName);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const column = await (0, _dataHelpers.getColumnByIdOrName)(context, param.columnName, model);
        if (!column || !(0, _nocodbsdk.isLinksOrLTAR)(column)) _catchError.NcError.badRequest('Column is not LTAR');
        const data = await baseModel.mmList({
            colId: column.id,
            parentId: param.rowId
        }, param.query);
        const count = await baseModel.mmListCount({
            colId: column.id,
            parentId: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, _extends({
            count
        }, param.query));
    }
    async mmExcludedList(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        if (!model) _catchError.NcError.tableNotFound(param.tableName);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const column = await (0, _dataHelpers.getColumnByIdOrName)(context, param.columnName, model);
        const data = await baseModel.getMmChildrenExcludedList({
            colId: column.id,
            pid: param.rowId
        }, param.query);
        const count = await baseModel.getMmChildrenExcludedListCount({
            colId: column.id,
            pid: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, _extends({
            count
        }, param.query));
    }
    async hmExcludedList(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        if (!model) _catchError.NcError.tableNotFound(param.tableName);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const column = await (0, _dataHelpers.getColumnByIdOrName)(context, param.columnName, model);
        const data = await baseModel.getHmChildrenExcludedList({
            colId: column.id,
            pid: param.rowId
        }, param.query);
        const count = await baseModel.getHmChildrenExcludedListCount({
            colId: column.id,
            pid: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, _extends({
            count
        }, param.query));
    }
    async btExcludedList(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        if (!model) _catchError.NcError.tableNotFound(param.tableName);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const column = await (0, _dataHelpers.getColumnByIdOrName)(context, param.columnName, model);
        const data = await baseModel.getBtChildrenExcludedList({
            colId: column.id,
            cid: param.rowId
        }, param.query);
        const count = await baseModel.getBtChildrenExcludedListCount({
            colId: column.id,
            cid: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, _extends({
            count
        }, param.query));
    }
    async ooExcludedList(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        if (!model) _catchError.NcError.notFound('Table not found');
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const column = await (0, _dataHelpers.getColumnByIdOrName)(context, param.columnName, model);
        const data = await baseModel.getExcludedOneToOneChildrenList({
            colId: column.id,
            cid: param.rowId
        }, param.query);
        const count = await baseModel.countExcludedOneToOneChildren({
            colId: column.id,
            cid: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, _extends({
            count
        }, param.query));
    }
    // todo: handle case where the given column is not ltar
    async hmList(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        if (!model) _catchError.NcError.tableNotFound(param.tableName);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const column = await (0, _dataHelpers.getColumnByIdOrName)(context, param.columnName, model);
        if (!(0, _nocodbsdk.isLinksOrLTAR)(column)) _catchError.NcError.badRequest('Column is not LTAR');
        const data = await baseModel.hmList({
            colId: column.id,
            id: param.rowId
        }, param.query);
        const count = await baseModel.hmListCount({
            colId: column.id,
            id: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, _extends({
            count
        }, param.query));
    }
    async relationDataRemove(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        if (!model) _catchError.NcError.tableNotFound(param.tableName);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const column = await (0, _dataHelpers.getColumnByIdOrName)(context, param.columnName, model);
        await baseModel.removeChild({
            colId: column.id,
            childId: param.refRowId,
            rowId: param.rowId,
            cookie: param.cookie
        });
        return true;
    }
    // todo: Give proper error message when reference row is already related and handle duplicate ref row id in hm
    async relationDataAdd(context, param) {
        const { model, view } = await (0, _dataHelpers.getViewAndModelByAliasOrId)(context, param);
        if (!model) _catchError.NcError.tableNotFound(param.tableName);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        const column = await (0, _dataHelpers.getColumnByIdOrName)(context, param.columnName, model);
        await baseModel.addChild({
            colId: column.id,
            childId: param.refRowId,
            rowId: param.rowId,
            cookie: param.cookie
        });
        return true;
    }
};
DataAliasNestedService = _ts_decorate([
    (0, _common.Injectable)()
], DataAliasNestedService);
